<template>

    <div class="social" v-bind:class="'social--' + customClass"> 
        <ul class="social__list">
            <li class="social__item">
                <a href="https://www.facebook.com/SousaBrancoArt/" class="social__link" target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" class="social__icon social__icon--facebook">
                        <use  v-bind="{'xlink:href': socialSprite + '#facebook'}" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                    </svg>
                </a>
            </li>
            <li class="social__item">
                <a href="mailto:contato@sousabranco.com" class="social__link" target="_top">
                    <svg xmlns="http://www.w3.org/2000/svg" class="social__icon social__icon--mail">
                        <use v-bind="{'xlink:href': socialSprite + '#mail'}" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                    </svg>
                </a>
            </li>
            <li class="social__item">
                <a href="https://www.instagram.com/sousabranco_art/" class="social__link" target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" class="social__icon social__icon--instagram">
                        <use v-bind="{'xlink:href': socialSprite + '#instagram'}" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                    </svg>
                </a>
            </li>
        </ul>


    </div>

</template>
<script>
const socialSprite = require("@/assets/social-sprite.svg");

export default {
  computed: {
    socialSprite: function() {
      return socialSprite;
    },
  },
  props: {
    customClass: String,
  },
};
</script>
<style lang="scss">
.social {
  position: absolute;

  &--home {
    bottom: 4rem;
    right: 15%;

    @include respond(tab-port) {
      display: none;
    }
  }

  &--footer {
    position: static;

    & .social__list {
      margin: 0 auto;
      display: inline-block;
    }
  }

  &__list {
    @include clearfix;
  }

  &__item {
    float: left;

    &:not(:last-of-type) {
      margin-right: 6rem;
    }
  }

  &__link {
    display: block;
  }

  &__icon {
    width: 2rem;
    height: 2rem;
    fill: $color-cream;
    transition: all 0.2s;

    &--facebook {
      &:hover {
        fill: #7c89a5;
      }
    }

    &--instagram {
      &:hover {
        fill: #dd6f94;
      }
    }

    &--mail {
      &:hover {
        fill: #ff8833;
      }
    }
  }
}
</style>
